import { render, staticRenderFns } from "./footerBtn.vue?vue&type=template&id=6c17f5cf&scoped=true"
import script from "./footerBtn.vue?vue&type=script&lang=js"
export * from "./footerBtn.vue?vue&type=script&lang=js"
import style0 from "./footerBtn.vue?vue&type=style&index=0&id=6c17f5cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c17f5cf",
  null
  
)

export default component.exports